<app-monitor-layout #monitorContainer
  [test]="test"
  [testLoading]="testLoading$ | async"
  [patient]="patient"
  [bundle]="bundle"
  [screen]="currentDeviceScreen"
  [isTestDone]="isTestDone"
  [isTestSyncing]="isTestSyncing"
  [deviceLoading]="deviceLoading$ | async"
  [device]="device"
  [batteryPercentage]="batteryPercentage"
  [streamPopupVisible]="streamPopupVisible"
  [isSingleImage]="isSingleImage"
  [isV2Streaming]="isV2Streaming"
  [deviceActionLoading]="deviceActionLoading"
  [isLoading]="isLoading"
  [headsetAlignment]="headsetAlignment"
  (onClose)="close()"
  (onStreamOpen)="openStream($event)"
  (onStreamClose)="closeStream()"
  (onActionClicked)="onActionClicked($event)">

  <div class="monitor_container-column">
    <div class="monitor_graph-box">
      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      <div class="monitor_graph-title">{{ 'right' | translate | titlecase }}</div>
      @if (state && !isBluePupil) {
        <div class="monitor_eye-box">
          @if (isODStimulation || isODStimulationUpper || isODStimulationLower || isODAPD || isODReact) {
            <div>
              <i
                class="fas fa-eye fa-4x"
              [ngClass]="{ 'text--blink': state.od_state?.is_currently_tested || isODAPD, 
                            'faded-more': !state.od_state?.is_currently_tested && !isODAPD }">
              </i>
            </div>
            <span [ngClass]="{ 'faded-more': !state.od_state?.is_currently_tested }">
              @if (isODStimulationUpper) {
                {{ 'stimulationUpper' | translate }}
              }
              @if (isODStimulationLower) {
                {{ 'stimulationLower' | translate }}
              }
              @if (isODStimulation) {
                {{ 'stimulation' | translate }}
              }
              @if (isODAPD) {
                {{ 'APD' | translate }}
              }
              @if (isODReact) {
                {{ 'react' | translate }}
              }
            </span>
            @if (state.od_state?.is_retesting) {
              <ng-container *ngTemplateOutlet="repeatingTemplate"></ng-container>
            }
          } @else {
            @if (isODAdaptation || isODPhaseL || isODPhaseD) {
              <app-hourglass [offset]="odOffset"></app-hourglass>
              <i class="fas fa-moon"></i>&nbsp;
              @if (isODAdaptation) {
                {{ 'darkAdaptation' | translate }}
              }
              @if (isODPhaseL) {
                {{ 'phaseL' | translate }}
              }
              @if (isODPhaseD) {
                {{ 'phaseD' | translate }}
              }
              @if (state.od_state?.is_retesting) {
                <ng-container *ngTemplateOutlet="repeatingTemplate"></ng-container>
              }
            } @else {
              <small>{{ 'noTestingPeriods' | translate }}</small>
            }
          }
        </div>
      }
      @if (isBluePupil) {
        <div class="monitor_eye-box">
          <span class="text--blink">{{isTestDone ? ('testDone' | translate | titlecase) : (('inProgress' | translate | titlecase) + '...') }}</span>
        </div>
      }
    </div>

    <div class="monitor_graph-box">
      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      <div class="monitor_graph-title">{{ 'left' | translate | titlecase }}</div>
      @if (state && !isBluePupil) {
        <div class="monitor_eye-box">
          @if (isOSStimulation || isOSStimulationUpper || isOSStimulationLower || isOSAPD || isOSReact) {
            <div>
              <i
                class="fas fa-eye fa-4x"
              [ngClass]="{ 'text--blink': state.os_state?.is_currently_tested || isOSAPD, 
                            'faded-more': !state.os_state?.is_currently_tested && !isOSAPD}">
              </i>
            </div>
            <span [ngClass]="{ 'faded-more': !state.os_state?.is_currently_tested }">
              @if (isOSStimulationUpper) {
                {{ 'stimulationUpper' | translate }}
              }
              @if (isOSStimulationLower) {
                {{ 'stimulationLower' | translate }}
              }
              @if (isOSStimulation) {
                {{ 'stimulation' | translate }}
              }
              @if (isOSAPD) {
                {{ 'APD' | translate }}
              }
              @if (isOSReact) {
                {{ 'react' | translate }}
              }
            </span>
            @if (state.os_state?.is_retesting) {
              <ng-container *ngTemplateOutlet="repeatingTemplate"></ng-container>
            }
          } @else {
            @if (isOSAdaptation || isOSPhaseL || isOSPhaseD) {
              <app-hourglass [offset]="osOffset"></app-hourglass>
              <i class="fas fa-moon"></i>&nbsp;
              @if (isOSAdaptation) {
                {{ 'darkAdaptation' | translate }}
              }
              @if (isOSPhaseL) {
                {{ 'phaseL' | translate }}
              }
              @if (isOSPhaseD) {
                {{ 'phaseD' | translate }}
              }
              @if (state.os_state?.is_retesting) {
                <ng-container *ngTemplateOutlet="repeatingTemplate"></ng-container>
              }
            } @else {
              <small>{{ 'noTestingPeriods' | translate }}</small>
            }
          }
        </div>
      }
      @if (isBluePupil) {
        <div class="monitor_eye-box">
          <span class="text--blink">{{isTestDone ? ('testDone' | translate | titlecase) : (('inProgress' | translate | titlecase) + '...') }}</span>
        </div>
      }
    </div>
  </div>


  <ng-template #repeatingTemplate>
    <br>
      <small class="faded-more">{{ (isVersionTwo ? 'repeating' : 'repeatingPupil') | translate }}</small>
    </ng-template>

    <div class="monitor_container-column">
      <div class="monitor_graph-box monitor_graph-box--single">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <app-percentage-circle
          id="test-percentage"
          class="monitor_circle-box"
          [percentage]="(isTestDone && isBluePupil) ? 100 : percentageDone">
        </app-percentage-circle>
      </div>
    </div>

  </app-monitor-layout>